import React from 'react';

export type AiDesignsDataSource = 'cache' | 'db' | 'run' | null;

export type DashboardAiDesignsSourceBadgeProps = {
    source: AiDesignsDataSource;
    theme?: 'dark' | 'light';
    className?: string;
};

const LABELS: Record<Exclude<AiDesignsDataSource, null>, string> = {
    cache: 'Source: Cache',
    db: 'Source: DB',
    run: 'Source: AI Run',
};

/** Small pill showing where the current AI design catalogue data was loaded from. */
export function DashboardAiDesignsSourceBadge({
    source,
    theme = 'light',
    className = '',
}: DashboardAiDesignsSourceBadgeProps) {
    if (!source) return null;
    return (
        <span
            className={`obd-ai-designs-source-badge obd-theme-${theme}${className ? ` ${className}` : ''}`}
            title={
                source === 'cache'
                    ? 'Layout options were restored from local browser cache'
                    : source === 'db'
                      ? 'Layout options were loaded from saved scenarios on the server'
                      : 'Layout options were generated by the latest AI run'
            }
        >
            {LABELS[source]}
        </span>
    );
}
